module.exports = __webpack_public_path__ + "static/img/logo2.8b9f81e.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/logo2.png
// module id = 4PW/
// module chunks = 2